import type { PhysicsBody } from "../PhysicsBody.ts";
import type { ForceGenerator } from "../ForceGenerator.ts";

/**
 * Pulls a body's value toward a fixed (but mutable) target.
 * target=0 + tension + friction on the body is exactly the "impulse-injection"
 * pattern used by StringImpulse today: rest position fixed at 0, external
 * events call `body.applyImpulse(dv)`, this force pulls it back.
 */
export class SpringForce implements ForceGenerator {
  constructor(
    public tension: number,
    public target = 0,
  ) {}

  compute(body: PhysicsBody): number {
    return this.tension * (this.target - body.value);
  }
}
